import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import * as Sentry from "@sentry/react";
import { supabaseIntegration } from "@supabase/sentry-js-integration";

import './index.css'
import { SupabaseClient } from '@supabase/supabase-js';

Sentry.init({
	dsn: "https://3fd8adb6d8f619ddee530099df343ad3@o4510811857092608.ingest.us.sentry.io/4510811858206720",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	environment: import.meta.env.VITE_NODE_ENV || "development",
	integrations: [
		Sentry.browserTracingIntegration(),
		// send console.log, console.warn, and console.error calls as logs to Sentry
		Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
		Sentry.replayIntegration({
			// NOTE: This will disable built-in masking. Only use this if your site
			// has no sensitive data, or if you've already set up other options for
			// masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
			maskAllText: false,
			blockAllMedia: false,
		}),
		supabaseIntegration(SupabaseClient, Sentry, {
			tracing: true,
			breadcrumbs: true,
			errors: true,
		}),
	],
	tracePropagationTargets: [
		"localhost", // Matches local development (e.g., supabase start)
		/^https:\/\/[a-z0-9]+\.functions\.supabase\.co/, // Matches all your production Edge Functions
	],
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: import.meta.env.VITE_NODE_ENV === "production" ? 0.1 : 1.0,
	// This sets the sample rate at 10%. You may want to change it to 100%
	// while in development and then sample at a lower rate in production.
	replaysSessionSampleRate: import.meta.env.VITE_NODE_ENV === "production" ? 0.1 : 1.0,
	// If you're not already sampling the entire session, change the sample
	// rate to 100% when sampling sessions where errors occur.,
	replaysOnErrorSampleRate: 1.0,
	enableLogs: true,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
)